module.exports = __webpack_public_path__ + "img/龙宫女.bc31bf98.png";